/*
  FF Product Quiz
  Questions and screen text: snippets/ff-quiz-config.liquid
  Products and when to recommend them: Recommendation blocks on the FF Product Quiz section
*/
(function () {
  'use strict';

  var STORE_KEY = 'ffq:v1';
  var SAVE_DAYS = 30;
  var EMAIL_RE = /^[^ @]+@[^ @]+[.][^ @.]{2,}$/;
  var QUOTE = String.fromCharCode(34);

  function esc(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split(QUOTE).join('&quot;')
      .split(`'`).join('&#39;');
  }
  function arr(v) { return v == null || v === '' ? [] : Array.isArray(v) ? v : [v]; }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function uid() { return Math.random().toString(36).slice(2, 10) + Date.now().toString(36); }

  function money(cents, fmt) {
    function num(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/([0-9])(?=([0-9]{3})+(?![0-9]))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var out = String(fmt || '${{amount}}').replace(/[{][{] *([a-z_]+) *[}][}]/, function (m, key) {
      if (key === 'amount_no_decimals') return num(0, ',', '.');
      if (key === 'amount_with_comma_separator') return num(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
      return num(2, ',', '.');
    });
    return out.replace(/<[^>]+>/g, '');
  }

  function track(name, params) {
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, params); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
  }
  function lead() {
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead'); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead'); } catch (e) {}
  }

  function Quiz(host) {
    this.host = host;
    this.stage = host.querySelector('[data-ffq-stage]');
    this.cfg = window.FFQuizConfig || { questions: [], text: {} };
    this.data = window.FFQuizData || { recs: [], text: {} };
    this.t = Object.assign({}, this.cfg.text);
    var over = this.data.text || {};
    for (var k in over) { if (over[k]) this.t[k] = over[k]; }
    this.sid = uid();
    this.answers = {};
    this.email = '';
    this.started = false;
    this.busy = false;
    this.added = {};
    this.result = null;
    this.view = {};
    this.catalog();
    this.bind();
    this.boot();
  }

  var Q = Quiz.prototype;

  /* Products and rules come from the Recommendation blocks. One product can have several blocks. */
  Q.catalog = function () {
    var products = (this.products = {});
    var rules = (this.rules = []);
    var order = 0;
    (this.data.recs || []).forEach(function (r) {
      var p = products[r.handle];
      if (!p) {
        p = products[r.handle] = Object.assign({ handle: r.handle, name: '', prefer: '', order: order++ }, r.product);
        p.rating = Number(p.rating) || 0;
        p.ratingCount = Number(p.ratingCount) || 0;
      }
      if (!p.name && r.name) p.name = r.name;
      if (!p.prefer && r.prefer) p.prefer = r.prefer;
      rules.push({
        handle: r.handle,
        format: r.format && r.format !== 'any' ? r.format : '',
        conds: (r.conds || []).filter(function (c) { return c && c !== 'none'; }),
        pts: Number(r.pts) || 0,
        why: r.why || ''
      });
    });
    Object.keys(products).forEach(function (h) { if (!products[h].name) products[h].name = products[h].title; });
  };

  Q.boot = function () {
    var picks = new URLSearchParams(window.location.search).get('picks');
    if (picks) {
      var r = this.fromPicks(picks);
      if (r) { this.result = r; this.showResults(r, true); return; }
    }
    this.showQuestion(0, true);
  };

  Q.saved = function () {
    try {
      var s = JSON.parse(window.localStorage.getItem(STORE_KEY) || 'null');
      if (s && s.answers && Date.now() - s.ts < SAVE_DAYS * 864e5) return s;
    } catch (e) {}
    return null;
  };
  Q.save = function () {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify({ answers: this.answers, ts: Date.now() })); } catch (e) {}
  };

  /* Questions to ask, given the answers so far (showIf = skip logic). */
  Q.visible = function () {
    var a = this.answers;
    return this.cfg.questions.filter(function (q) {
      if (!q.showIf) return true;
      return Object.keys(q.showIf).every(function (id) {
        var have = arr(a[id]);
        return arr(q.showIf[id]).some(function (w) { return have.indexOf(w) !== -1; });
      });
    });
  };
  Q.total = function () {
    var a = this.answers, vis = this.visible();
    return this.cfg.questions.filter(function (q) {
      if (vis.indexOf(q) !== -1) return true;
      return Object.keys(q.showIf || {}).some(function (id) { return a[id] == null; });
    }).length;
  };
  Q.prune = function () {
    var a = this.answers, changed = true;
    while (changed) {
      changed = false;
      var ids = this.visible().map(function (q) { return q.id; });
      Object.keys(a).forEach(function (k) { if (ids.indexOf(k) === -1) { delete a[k]; changed = true; } });
    }
  };

  Q.paint = function (html, wide, first) {
    this.busy = false;
    this.stage.className = 'ffq__stage' + (wide ? ' ffq__stage--wide' : '');
    this.stage.innerHTML = html;
    if (first) return;
    var r = this.host.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.6) this.host.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var h = this.stage.querySelector('[data-focus]');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  };

  Q.bar = function (pct, back) {
    return `<div class='ffq__top'>` +
      (back ? `<button type='button' class='ffq__back' data-act='back'>&larr; ${esc(this.t.back)}</button>` : '') +
      `<div class='ffq__progress' aria-hidden='true'><span style='width:${pct}%'></span></div></div>`;
  };

  Q.showQuestion = function (i, first) {
    var qs = this.visible(), q = qs[i], t = this.t;
    if (!q) return;
    var multi = q.type === 'multi';
    var picked = arr(this.answers[q.id]);
    this.view = { type: 'q', i: i, q: q };
    var html = '';
    if (first && i === 0 && this.saved()) {
      html += `<p class='ffq__saved'><button type='button' class='ffq__link' data-act='saved'>${esc(t.welcome_back)}</button></p>`;
    }
    html += this.bar(Math.round((i / (this.total() + 1)) * 100), i > 0);
    html += `<h2 class='ffq__title' tabindex='-1' data-focus>${esc(q.title)}</h2>`;
    if (q.hint) html += `<p class='ffq__hint'>${esc(q.hint)}</p>`;
    html += `<div class='ffq__opts${multi ? ' ffq__opts--multi' : ''}' role='group' aria-label='${esc(q.title)}'>`;
    q.answers.forEach(function (o) {
      var on = picked.indexOf(o.id) !== -1;
      html += `<button type='button' class='ffq__opt' data-act='opt' data-id='${esc(o.id)}' aria-pressed='${on}'>` +
        `<span class='ffq__mark' aria-hidden='true'></span><span><span class='ffq__opt-label'>${esc(o.label)}</span>` +
        (o.sub ? `<span class='ffq__opt-sub'>${esc(o.sub)}</span>` : '') + `</span></button>`;
    });
    html += `</div>`;
    if (multi) {
      html += `<div class='ffq__actions'><button type='button' class='ffq__btn' data-act='next'${picked.length ? '' : ' disabled'}>${esc(t.next)}</button></div>`;
    }
    this.paint(html, false, first);
  };

  Q.pick = function (btn) {
    var self = this, q = this.view.q, id = btn.getAttribute('data-id');
    if (!q || this.busy) return;
    if (!this.started) { this.started = true; track('ff_quiz_start'); this.send('started'); }
    var opts = this.stage.querySelectorAll('.ffq__opt');
    if (q.type !== 'multi') {
      this.answers[q.id] = id;
      opts.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      this.busy = true;
      window.setTimeout(function () { self.forward(); }, 240);
      return;
    }
    var exclusive = q.answers.filter(function (o) { return o.exclusive; }).map(function (o) { return o.id; });
    var cur = arr(this.answers[q.id]).slice(), at = cur.indexOf(id);
    if (at !== -1) cur.splice(at, 1);
    else if (exclusive.indexOf(id) !== -1) cur = [id];
    else { cur = cur.filter(function (x) { return exclusive.indexOf(x) === -1; }); cur.push(id); }
    this.answers[q.id] = cur;
    opts.forEach(function (b) { b.setAttribute('aria-pressed', cur.indexOf(b.getAttribute('data-id')) !== -1 ? 'true' : 'false'); });
    var next = this.stage.querySelector('[data-act=next]');
    if (next) next.disabled = !cur.length;
  };

  Q.forward = function () {
    this.prune();
    var i = this.view.i + 1;
    if (i < this.visible().length) this.showQuestion(i);
    else if (this.email) this.finish();
    else this.showEmail();
  };

  Q.back = function () {
    if (this.view.type === 'email') this.showQuestion(this.visible().length - 1);
    else if (this.view.type === 'q' && this.view.i > 0) this.showQuestion(this.view.i - 1);
  };

  Q.showEmail = function () {
    var t = this.t;
    this.view = { type: 'email' };
    this.paint(
      this.bar(92, true) +
      `<h2 class='ffq__title' tabindex='-1' data-focus>${esc(t.email_heading)}</h2>` +
      `<p class='ffq__hint'>${esc(t.email_text)}</p>` +
      `<form class='ffq__form' data-form='email' novalidate>` +
      `<input class='ffq__input' type='email' name='email' autocomplete='email' inputmode='email' placeholder='${esc(t.email_placeholder)}' aria-label='${esc(t.email_placeholder)}'>` +
      `<input class='ffq__hp' type='text' name='company' tabindex='-1' autocomplete='off' aria-hidden='true'>` +
      `<button type='submit' class='ffq__btn'>${esc(t.email_button)}</button></form>` +
      `<p class='ffq__error' data-error hidden></p>` +
      `<div class='ffq__actions'><button type='button' class='ffq__link' data-act='skip'>${esc(t.email_skip)}</button></div>` +
      (t.email_note ? `<p class='ffq__note'>${esc(t.email_note)}</p>` : '')
    );
  };

  Q.submitEmail = function (form) {
    var input = form.elements.email, v = (input.value || '').trim();
    var err = form.parentNode.querySelector('[data-error]');
    var later = form.getAttribute('data-form') === 'later';
    if (form.elements.company && form.elements.company.value) v = '';
    else if (!EMAIL_RE.test(v)) {
      if (err) { err.textContent = this.t.email_error; err.hidden = false; }
      input.focus();
      return;
    }
    this.email = v;
    if (!later) { this.finish(); return; }
    if (v) { this.send('email_added', this.payload()); track('ff_quiz_email'); lead(); }
    form.parentNode.innerHTML = `<p class='ffq__later-title'>${esc(this.t.later_done)}</p>`;
  };

  Q.finish = function () {
    this.prune();
    var r = (this.result = this.rank());
    this.save();
    this.showResults(r, false);
    this.setAttributes();
    this.send('completed', this.payload());
    track('ff_quiz_complete', { best_match: r.best ? this.products[r.best.handle].name : '' });
    if (this.email) { track('ff_quiz_email'); lead(); }
  };

  /*
    Ranking. Every matching block adds its Priority points to its product.
    Highest total = best match, next two = add-ons, next few = also a good fit.
    The why text comes from the most specific matching block.
  */
  Q.rank = function () {
    var a = this.answers, P = this.products, scores = {};
    this.rules.forEach(function (r) {
      var p = P[r.handle];
      if (!p || !p.available) return;
      if (r.format && a.format !== r.format) return;
      var ok = r.conds.every(function (c) {
        var at = c.indexOf(':');
        return arr(a[c.slice(0, at)]).indexOf(c.slice(at + 1)) !== -1;
      });
      if (!ok) return;
      var spec = (r.format ? 1 : 0) + r.conds.length;
      var s = scores[r.handle] || (scores[r.handle] = { handle: r.handle, pts: 0, why: '', spec: -1, top: -1 });
      s.pts += r.pts;
      if (r.why && (spec > s.spec || (spec === s.spec && r.pts > s.top))) { s.why = r.why; s.spec = spec; s.top = r.pts; }
    });
    var list = Object.keys(scores).map(function (h) { return scores[h]; }).filter(function (s) { return s.pts > 0; });
    list.sort(function (x, y) { return y.pts - x.pts || P[x.handle].order - P[y.handle].order; });
    var maxAlso = this.cfg.maxAlso == null ? 4 : this.cfg.maxAlso;
    return { best: list[0] || null, addons: list.slice(1, 3), also: list.slice(3, 3 + maxAlso) };
  };

  Q.top3 = function () {
    var r = this.result || {};
    return (r.best ? [r.best] : []).concat(r.addons || []);
  };

  Q.labels = function () {
    var a = this.answers, out = {};
    this.cfg.questions.forEach(function (q) {
      var have = arr(a[q.id]);
      out[q.id] = q.answers
        .filter(function (o) { return have.indexOf(o.id) !== -1; })
        .map(function (o) { return o.short || o.label; })
        .join(', ');
    });
    return out;
  };

  Q.payload = function () {
    var P = this.products, r = this.result || {};
    var names = this.top3().map(function (x) { return P[x.handle].name; });
    return {
      picks: names,
      pick_urls: this.top3().map(function (x) { return window.location.origin + P[x.handle].url; }),
      also: (r.also || []).map(function (x) { return P[x.handle].name; }),
      answers: this.labels(),
      results_url: this.data.pageUrl + '?picks=' + names.map(encodeURIComponent).join('~')
    };
  };

  /* Quiz answers ride along on the cart, so they show under Additional details on the order. */
  Q.setAttributes = function () {
    var labels = this.labels(), P = this.products, attrs = {};
    this.cfg.questions.forEach(function (q) { attrs[q.attr || 'quiz_' + q.id] = labels[q.id] || ''; });
    attrs.quiz_picks = this.top3().map(function (x) { return P[x.handle].name; }).join(' | ');
    fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  };

  Q.send = function (event, extra) {
    if (!this.data.webhook) return;
    var payload = Object.assign({
      event: event,
      session: this.sid,
      email: this.email || '',
      page: window.location.pathname,
      ts: new Date().toISOString()
    }, extra || {});
    try {
      var body = new URLSearchParams();
      body.append('payload', JSON.stringify(payload));
      fetch(this.data.webhook, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }).catch(function () {});
    } catch (e) {}
  };

  /* Buying options for a product: its variants, and subscription plans if it has them. */
  Q.choices = function (p) {
    if (p._ch) return p._ch;
    var out = [], many = p.variants.length > 1;
    p.variants.forEach(function (v) {
      if (!v.available) return;
      var base = many ? v.title : '';
      var plans = v.plans || [];
      if (!p.requiresPlan || !plans.length) out.push({ id: v.id, label: base, price: v.price, compare: v.compare || 0 });
      plans.forEach(function (pl) {
        out.push({ id: v.id, plan: pl.id, label: (base ? base + ' / ' : '') + pl.name, price: pl.price, compare: 0 });
      });
    });
    return (p._ch = out);
  };
  Q.defaultChoice = function (p) {
    var ch = this.choices(p), want = (p.prefer || '').toLowerCase();
    if (want) {
      for (var i = 0; i < ch.length; i++) { if (ch[i].label.toLowerCase().indexOf(want) !== -1) return i; }
    }
    return 0;
  };
  Q.choice = function (card) {
    var p = this.products[card.getAttribute('data-handle')];
    var sel = card.querySelector('select[data-choice]');
    return this.choices(p)[sel ? Number(sel.value) : this.defaultChoice(p)];
  };
  Q.priceHtml = function (c) {
    var fmt = this.data.moneyFormat;
    return esc(money(c.price, fmt)) + (c.compare > c.price ? ` <s>${esc(money(c.compare, fmt))}</s>` : '');
  };

  Q.card = function (item, tier) {
    var self = this, p = this.products[item.handle], t = this.t;
    var ch = this.choices(p), def = this.defaultChoice(p);
    if (!ch.length) return '';
    var link = ` href='${esc(p.url)}' target='_blank' rel='noopener'`;
    var html = `<article class='ffq__card ffq__card--${tier}' data-handle='${esc(item.handle)}'>`;
    if (tier === 'best') html += `<span class='ffq__badge'>${esc(t.best)}</span>`;
    if (p.image) {
      html += `<a class='ffq__card-media'${link} tabindex='-1' aria-hidden='true'><img src='${esc(p.image)}' alt='' loading='lazy' width='640' height='640'></a>`;
    }
    html += `<div class='ffq__card-body'><h3 class='ffq__card-title'><a${link}>${esc(p.title)}</a></h3>`;
    if (p.rating > 0 && p.ratingCount > 0) {
      html += `<div class='ffq__rating'><span class='ffq__stars' role='img' aria-label='${p.rating.toFixed(1)} out of 5 stars'>` +
        `<span style='width:${Math.min(100, (p.rating / 5) * 100).toFixed(1)}%'></span></span><span>${p.ratingCount} ${esc(t.reviews)}</span></div>`;
    }
    if (item.why) html += `<p class='ffq__why'><strong>${esc(t.why)}</strong> ${esc(item.why)}</p>`;
    if (ch.length > 1) {
      html += `<select class='ffq__select' data-choice aria-label='${esc(t.choose)}'>`;
      ch.forEach(function (c, i) {
        html += `<option value='${i}'${i === def ? ' selected' : ''}>${esc(c.label)} (${esc(money(c.price, self.data.moneyFormat))})</option>`;
      });
      html += `</select>`;
    }
    html += `<div class='ffq__price' data-price>${this.priceHtml(ch[def])}</div>`;
    html += `<div class='ffq__card-actions'><button type='button' class='ffq__btn ffq__btn--small' data-act='add'>${esc(t.add)}</button>` +
      `<a class='ffq__view'${link}>${esc(t.view)}</a></div>`;
    html += `<p class='ffq__error' data-error hidden></p></div></article>`;
    return html;
  };

  Q.showResults = function (r, fromLink) {
    var self = this, t = this.t, n = this.top3().length;
    this.view = { type: 'results' };
    var html = `<h2 class='ffq__title' tabindex='-1' data-focus>${esc(fromLink ? t.picks_heading : t.results_heading)}</h2>`;
    html += `<p class='ffq__hint'>${esc(fromLink ? t.picks_text : t.results_text)}</p>`;
    if (r.best) html += `<div class='ffq__group'>${this.card(r.best, 'best')}</div>`;
    if (r.addons.length) {
      html += `<div class='ffq__group'><h3 class='ffq__group-title'>${esc(t.addons)}</h3><div class='ffq__grid'>` +
        r.addons.map(function (x) { return self.card(x, 'addon'); }).join('') + `</div></div>`;
    }
    if (r.also.length) {
      html += `<div class='ffq__group'><h3 class='ffq__group-title'>${esc(t.also)}</h3><div class='ffq__rows'>` +
        r.also.map(function (x) { return self.card(x, 'also'); }).join('') + `</div></div>`;
    }
    html += `<div class='ffq__footer'>`;
    if (n > 1) html += `<button type='button' class='ffq__btn' data-act='add-all'>${esc(t.add_all.replace('{n}', n))}</button>`;
    html += `<button type='button' class='ffq__link' data-act='retake'>${esc(t.retake)}</button></div>`;
    if (!this.email && !fromLink && this.data.webhook) {
      html += `<div class='ffq__later'><p class='ffq__later-title'>${esc(t.later_heading)}</p>` +
        `<form class='ffq__form' data-form='later' novalidate>` +
        `<input class='ffq__input' type='email' name='email' autocomplete='email' inputmode='email' placeholder='${esc(t.email_placeholder)}' aria-label='${esc(t.email_placeholder)}'>` +
        `<input class='ffq__hp' type='text' name='company' tabindex='-1' autocomplete='off' aria-hidden='true'>` +
        `<button type='submit' class='ffq__btn'>${esc(t.later_button)}</button></form>` +
        `<p class='ffq__error' data-error hidden></p></div>`;
    }
    this.paint(html, true, false);
  };

  Q.cartAdd = function (items) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok) throw new Error(j.description || j.message || '');
        return j;
      });
    }).then(function (j) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
      return j;
    });
  };

  Q.line = function (card) {
    var c = this.choice(card), item = { id: c.id, quantity: 1 };
    if (c.plan) item.selling_plan = c.plan;
    return item;
  };

  Q.run = function (btn, cards, errorBox) {
    var self = this, t = this.t, label = btn.textContent;
    var todo = cards.filter(function (c) { return !self.added[c.getAttribute('data-handle')]; });
    if (!todo.length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
      return;
    }
    if (errorBox) errorBox.hidden = true;
    btn.disabled = true;
    btn.textContent = t.adding;
    this.cartAdd(todo.map(function (c) { return self.line(c); })).then(function () {
      todo.forEach(function (c) { self.added[c.getAttribute('data-handle')] = true; });
      track('ff_quiz_add_to_cart', { items: todo.length });
      btn.textContent = t.added;
      window.setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2200);
    }).catch(function (e) {
      btn.disabled = false;
      btn.textContent = label;
      if (errorBox) { errorBox.textContent = e.message || t.cart_error; errorBox.hidden = false; }
    });
  };

  Q.addOne = function (btn) {
    var card = btn.closest('.ffq__card');
    delete this.added[card.getAttribute('data-handle')];
    this.run(btn, [card], card.querySelector('[data-error]'));
  };

  Q.addAll = function (btn) {
    var cards = Array.prototype.slice.call(this.stage.querySelectorAll('.ffq__card--best, .ffq__card--addon'));
    this.run(btn, cards, null);
  };

  Q.openSaved = function () {
    var s = this.saved();
    if (!s) return;
    this.answers = s.answers;
    this.prune();
    this.result = this.rank();
    this.showResults(this.result, false);
  };

  Q.retake = function () {
    this.answers = {};
    this.added = {};
    this.result = null;
    if (window.location.search.indexOf('picks=') !== -1 && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    this.showQuestion(0);
  };

  /* Opens saved picks from an email link: ?picks=Name~Name~Name */
  Q.fromPicks = function (str) {
    var P = this.products, handles = Object.keys(P), found = [];
    String(str).split('~').forEach(function (raw) {
      var n = raw.trim().toLowerCase();
      if (!n) return;
      var h = handles.filter(function (k) {
        var p = P[k];
        return p.available && (p.name.toLowerCase() === n || k === n || p.title.toLowerCase() === n);
      })[0];
      if (h && found.indexOf(h) === -1) found.push(h);
    });
    if (!found.length) return null;
    var s = this.saved();
    if (s) {
      this.answers = s.answers;
      this.prune();
      this.result = this.rank();
      var same = this.top3().map(function (x) { return x.handle; }).join('|') === found.slice(0, 3).join('|');
      if (same) return this.result;
      this.answers = {};
    }
    var items = found.slice(0, 3).map(function (h) { return { handle: h, why: '' }; });
    return { best: items[0], addons: items.slice(1), also: [] };
  };

  Q.bind = function () {
    var self = this;
    this.stage.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || !self.stage.contains(b)) return;
      var act = b.getAttribute('data-act');
      if (act === 'opt') self.pick(b);
      else if (act === 'next') self.forward();
      else if (act === 'back') self.back();
      else if (act === 'skip') self.finish();
      else if (act === 'saved') self.openSaved();
      else if (act === 'retake') self.retake();
      else if (act === 'add') self.addOne(b);
      else if (act === 'add-all') self.addAll(b);
    });
    this.stage.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-form]');
      if (!f) return;
      e.preventDefault();
      self.submitEmail(f);
    });
    this.stage.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-choice]');
      if (!s) return;
      var card = s.closest('.ffq__card');
      card.querySelector('[data-price]').innerHTML = self.priceHtml(self.choice(card));
    });
  };

  function init() {
    document.querySelectorAll('[data-ffq]').forEach(function (host) {
      if (host.__ffq) return;
      try { host.__ffq = new Quiz(host); } catch (e) { if (window.console) window.console.error('FF quiz failed to start', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
